import React from "react";
import { UPDATES } from "@/lib/services";
import { Megaphone } from "lucide-react";

export const Ticker = () => (
  <div className="bg-[#FFF9C4] border-y border-[#DAA520]/50 overflow-hidden" data-testid="updates-ticker">
    <div className="max-w-full flex items-stretch">
      <div className="flex items-center gap-2 bg-[#E65100] text-white px-4 py-2 font-bold text-xs uppercase tracking-wider shrink-0 z-10">
        <Megaphone className="w-4 h-4" /> Latest Updates
      </div>
      <div className="relative flex-1 overflow-hidden py-2">
        <div className="ttd-marquee-track">
          {[...UPDATES, ...UPDATES].map((u, i) => (
            <span key={i} className="mx-8 text-sm font-semibold text-[#BF360C]">
              ★ {u}
            </span>
          ))}
        </div>
      </div>
    </div>
  </div>
);
